import { FC, useCallback, useContext } from "react";
import {
    CasinoScopesMap,
    formatCasinoProviderName,
    useLayoutCasinoConfig,
} from "@finbackoffice/site-core";
import {
    CasinoSectionsEnum,
    CasinoSectionsStyleEnum,
    CasinoWidgetFolderEnum,
    ILayoutsCasinoSection,
} from "@finbackoffice/fe-core";
import { ICasinoGame } from "@finbackoffice/clientbff-client";
import Loading from "components/base/loading/Loading";
import Translate from "components/base/translate/Translate";
import { CasinoGameImgFolderType } from "utils/helpers";
import { CasinoContext } from "../../Casino";
import { CasinoGameItem } from "../../game-item/CasinoGameItem";
import styles from "./compact.module.sass";

const Compact: FC = () => {
    const { casinoGamesState, hasMore, endRef, hideTag, gameTypes, isSlots, imgFolder } =
        useContext(CasinoContext);
    const { casinoWidgetsConfig } = useLayoutCasinoConfig(isSlots ? "slots" : "livecasino");

    /* const getFallbackSrc = useCallback(
        (game: ICasinoGame, variant: "" | CasinoSectionsStyleEnum.Narrow) => {
            if (variant === CasinoSectionsStyleEnum.Narrow) {
                return game.image_portrait;
            }

            return undefined;
        },
        [],
    ); */

    const getImgSrcFolder = useCallback(
        (
            variant: "" | CasinoSectionsStyleEnum.Narrow,
            game: ICasinoGame,
        ): CasinoGameImgFolderType | undefined => {
            if (variant === CasinoSectionsStyleEnum.Narrow) {
                return "narrow";
            } else if (imgFolder && imgFolder === CasinoWidgetFolderEnum.Central) {
                return `${imgFolder}/${formatCasinoProviderName(game.category)}`;
            }

            return undefined;
        },
        [imgFolder],
    );

    const renderSection = useCallback(
        (section: ILayoutsCasinoSection, index: number) => {
            if (section.enable) {
                switch (section.name) {
                    case CasinoSectionsEnum.All:
                        if (Boolean(casinoGamesState.games.length)) {
                            return (
                                <div
                                    key={index}
                                    className={
                                        section.style === CasinoSectionsStyleEnum.Narrow
                                            ? styles.casinoGamesNarrow
                                            : styles.casinoGames
                                    }
                                    data-testid="sportsbook-livecasino-games-container">
                                    {casinoGamesState.games.map((game) => (
                                        <CasinoGameItem
                                            key={game.id}
                                            game={game}
                                            hidePlayButtons={gameTypes !== CasinoScopesMap.slots}
                                            // fallbackSrc={getFallbackSrc(game, section.style)}
                                            hideTag={[hideTag]}
                                            imgFolder={getImgSrcFolder(section.style, game)}
                                        />
                                    ))}
                                    {hasMore && <div ref={endRef} />}
                                </div>
                            );
                        }
                        return null;
                    default:
                        return null;
                }
            }

            return null;
        },
        [casinoGamesState.games, endRef, gameTypes, getImgSrcFolder, hasMore, hideTag],
    );

    return (
        <>
            {casinoWidgetsConfig.map(renderSection)}
            {!casinoGamesState.loading && !Boolean(casinoGamesState.games.length) && (
                <div className="no-game">
                    <Translate tid="no_games" />
                </div>
            )}
            {casinoGamesState.loading && <Loading />}
        </>
    );
};

export default Compact;
